<template lang="pug">
include ../Bemto
+b.auth-modal
  +b.close-modal(
    @click.prevent='$emit("close")'
  )
    +b.APP-ICON(name="icon-cross")
  +b.P.text.--weight-bold.--size-2lg.--size-xl-sm.--color-black.--font-serif(style="margin-bottom: 20px") {{ _('Вітаю! Підписуйся на наш чат-бот!') }}
  telegram-prompt.ma--b-sm(
    :style="{margin: '0 auto'}"
  )
</template>

<script>

export default {
  mounted() {
    const { ROLE } = window

    if ('client' === ROLE) {
      this.close()
    }

    sessionStorage.setItem('modalShow', true)
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
}
</script>
